import { Modal, Tabs, Tooltip } from "antd";
import React, { useEffect, useState } from "react";
import { LazyLoadImage } from "react-lazy-load-image-component";
import { useHistory } from "react-router-dom";
import { fetchTestApi } from "../../../api/fetchTest";
import TestInstruction from "../../../components/testInstruction/testInstruction";
import dashboardJson from "../../../helper/constant/dashboard.json";
import { cancelFullScreen, getFullScreen } from "../../../helper/fullscreen";
import { getStudentData, setLocalStorage } from "../../../helper/localStorage";
import { objectValidation } from "../../../helper/validation";
import { AnswerContext } from "../../../store/answerStore";
import { HelperContext } from "../../../store/helperStore";
import { LaunchTestContext } from "../../../store/launchTestStore";
const { TabPane } = Tabs;

export default function MAPPR() {
  setLocalStorage("isScreenReloaded", false);
  const history = useHistory();
  const dashModal = JSON.parse(localStorage.getItem("dashModal"));
  const [visible, setVisible] = useState(dashModal === "1");
  const { helperC, dispatchHelper } = HelperContext();
  const { launchTestC, dispatchLaunchTest } = LaunchTestContext();
  const { answerC, dispatchAnswer } = AnswerContext();
  const { launchTestData, err, loader } = launchTestC;
  const [instVisible, setInstVisible] = useState(false);

  console.log("instVisible", instVisible);

  const getDemoTest = (testName) => {
    return dashboardJson.data.filter((data) => data.group_name === testName)[0];
  };

  useEffect(() => {
    // this condition applies when user coming back after taking the test
    if (helperC.testType === "DEMO") {
      setInstVisible(true);
    }
    cancelFullScreen();
    dispatchAnswer({ type: "RESET_ANSWER" });
    dispatchHelper({ type: "OFF_HEIGHT", payload: 0 });
    dispatchHelper({ type: "TEST_TYPE", payload: "" });
    dispatchHelper({ type: "FACE_DATA", payload: false });
    dispatchHelper({ type: "RUNNING_QUES_ID", payload: "" });
    dispatchHelper({ type: "RESET_AUDIO_STAT" });
  }, []);

  const memoryProcess = getDemoTest("Memory Processes");
  const acquireKnowledge = getDemoTest("Acquired Knowledge");
  const processingEfficiency = getDemoTest("Processing Efficiency");
  const perceptualProcess = getDemoTest("Perceptual Processes");
  const reasoningAbility = getDemoTest("Reasoning Ability");

  const handleCardClick = (testData) => {
    setInstVisible(true);
    const constGradeId = getStudentData().grade_id;
    fetchTestApi(
      testData.test_id,
      constGradeId, // variable grade id
      dispatchLaunchTest,
      dispatchHelper //for storing first question id
    );
    // setInstVisible(true);
  };

  const handleLaunchTest = () => {
    dispatchHelper({
      type: "TEST_TYPE",
      payload: "DEMO",
    });

    history.push({
      pathname: `/amaze_test`,
      state: { routeFrom: "dashboard" },
    });
    getFullScreen();
  };

  const getTest = (test) => {
    console.log(test);
    return (
      objectValidation(test) &&
      test.test.map((data, index) => {
        console.log("my data new ", data);
        return (
          <Card
            key={index}
            handleCardClick={() => handleCardClick(data)}
            data={data}
            group_color={test.group_color}
          ></Card>
        );
      })
    );
  };

  const handleCancel = () => {
    localStorage.removeItem("dashModal");
    setVisible(false);
  };
  const handleContinue = () => {
    setVisible(false);
    localStorage.removeItem("dashModal");
    history.push("/survey");
  };

  const getTabPane = (name, tip) => {
    return (
      <Tooltip title={tip}>
        <span>{name}</span>
      </Tooltip>
    );
  };

  const handleTabChange = (tabMove) => {
    dispatchHelper({ type: "MAPPR_TAB_MOVE", payload: tabMove });
  };

  return (<>
      <Tabs
        className="dashBoard-tab"
        defaultActiveKey={helperC.mapprTab}
        onChange={handleTabChange}
      >
        <TabPane
          tab={getTabPane(
            "Memory Processes",
            "Ability to take in information, store it, and recall it later"
          )}
          key="1"
        >
          <div className="test-list">{getTest(memoryProcess)}</div>
        </TabPane>
        <TabPane
          tab={getTabPane(
            "Acquired Knowledge",
            "Knowledge obtained from environment around us"
          )}
          key="2"
        >
          <div className="test-list">{getTest(acquireKnowledge)}</div>
        </TabPane>
        <TabPane
          tab={getTabPane(
            "Processing Efficiency",
            "Ability to focus one's attention and apply effort to a timed task"
          )}
          key="3"
        >
          <div className="test-list">{getTest(processingEfficiency)}</div>
        </TabPane>
        <TabPane
          tab={getTabPane(
            "Perceptual Processes",
            "Ability to organize, interpret and respond to a variety of stimuli"
          )}
          key="4"
        >
          <div className="test-list">{getTest(perceptualProcess)}</div>
        </TabPane>
        <TabPane
          tab={getTabPane(
            "Reasoning Ability",
            "Ability to identify, evaluate and make a decision while solving a problem"
          )}
          key="5"
        >
          <div className="test-list">{getTest(reasoningAbility)}</div>
        </TabPane>
      </Tabs>

      <Modal
        visible={visible}
        className="sml-modal"
        title="SURVEY"
        footer={
          <div className="sml-footer">
            <button className="custom-btn sml-btn" onClick={handleCancel}>
              Cancel
            </button>
            <button className="custom-btn" onClick={handleContinue}>
              Continue
            </button>
          </div>
        }
      >
        <h2 style={{ textAlign: "center" }}>
          Please take this survey to provide some additional information about
          the test taker.
        </h2>
      </Modal>

      <Modal
        style={{ top: 12, maxWidth: "1082px" }}
        width="98%"
        visible={instVisible}
        className="sml-modal dash-inst"
        onCancel={() => setInstVisible(false)}
        footer={null}
      >
        <TestInstruction
          launchTestData={launchTestData}
          handleBtn1={() => handleLaunchTest()}
          btnName1="Take Demo"
        ></TestInstruction>
      </Modal>
    </>
  );
}

const Card = (props) => (
  <Tooltip title={props.data.intro3}>
    <div
      className="dash-test-card"
      style={{
        background: props.group_color,
      }}
      onClick={props.handleCardClick}
    >
      <div className="dash-test-card-img">
        <LazyLoadImage
          // placeholderSrc={placeholderIcon}
          alt=""
          // effect="blur"
          src={
            props.data.test_id
              ? require(`../../../assets/img/startTest/cardImg/ic_${props.data.test_id}.svg`)
              : ""
          }
        />
      </div>
      <div className="card-title">
        <h3 className="">{props.data.test_name}</h3>
      </div>
    </div>
  </Tooltip>
);